import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import KeplerGl from "@kepler.gl/components";
import { CardComponent, CardRow } from '../../components/Layouts/Card.styles'
import Typography from '../../components/Basics/Typography'
import { Button, DatePicker, DatePickerInput, ProgressBar } from '@carbon/react'
import { useDatePicker } from '../../components/Inputs/Inputs.hooks'
import { onGetMapboxThunk } from "./Kepler.actions";
import { checkErrorRequired } from "../../modules/errors/validations";
import LoadingContent from '../../components/Animations/LoadingContent'
import keplerConfig from '../../data/cycle-kepler'
import { processCsvData, processGeojson } from '@kepler.gl/processors';
import { addDataToMap } from '@kepler.gl/actions';
import InformationContainer from "../../components/Basics/Information.container";
import Card from '../../components/Layouts/Card'
import { Map, Launch } from '@carbon/icons-react'
import frentes from '../../assets/geocercas/frentes_geocercas.json'
import layer from '../../assets/geocercas/layer.json'

const MAPBOX_TOKEN = "pk.eyJ1Ijoiam9zZS12YWxsZWpvczE0MTIiLCJhIjoiY205YWZqajQzMDRwYjJxcTQyZ2dxZGZ1cSJ9.z7BDDJD9HcS6vz_mk-EAsw";

const KeplerMapContainer = () => {
  const today = new Date()
  const dispatch = useDispatch();
  const { loading, error, cycleData, progress, loaded, total } = useSelector(state => state.mapbox);
  useEffect(() => {
    if (!cycleData || cycleData.length === 0) {
      const emptyCsv = `lat,lon\n0,0`;
      const emptyData = processCsvData(emptyCsv);
      dispatch(
        addDataToMap({
          datasets: [
            {
              data: emptyData,
              info: { label: 'placeholder', id: 'placeholder' }
            }
          ],
          config: {
            version: 'v1',
            config: {
              mapState: {
                latitude: -23.515,
                longitude: -68.37,
                zoom: 12,        // puedes ajustar si quieres más o menos zoom
                bearing: 0,
                pitch: 0
              },
              mapStyle: {
                styleType: "satellite",
              }
            }
          }

        })
      );
    }
  }, []);

  const progressInMB = (loaded / (1024 * 1024)).toFixed(1);
  const totalInMB = (total / (1024 * 1024)).toFixed(1);

  const helperText = progress > 0 && progress < 100
    ? `${progressInMB}MB of ${totalInMB}MB`
    : (progress === 100 ? 'Done' : 'Fetching assets...');

  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  const { error: dateError, value: dateValue, onChange: handleDateChange } = useDatePicker({
    initialValue: [yesterday],
    errorCallbacks: [checkErrorRequired()]
  })
  const dispatchReport = (date) => {
    handleDateChange(date)
    dispatch(onGetMapboxThunk(date))
  }

  // useEffect(() => {
  //   if (!loading) {
  //     return
  //   }
  //   dispatch(onGetMapboxThunk())
  // }, [])

  useEffect(() => {
    if (cycleData.length > 0) {
      const data = processCsvData(cycleData)
      const geoData = processGeojson(frentes);
      const newLayer = processGeojson(layer)
      const datasets = [
        {
          data: data,
          info: {
            id: 'my_data',
            label: 'GPS Data'
          }
        },
        {
          data: geoData,
          info: {
            id: '-mxgg0v', // 👈 this MUST match the dataId in your keplerConfig for "geocercas"
            label: 'geocercas'
          }
        },
        {
          data: newLayer,
          info: {
            id: 'newLayer', // 👈 this MUST match the dataId in your keplerConfig for "geocercas"
            label: 'Label'
          }
        }
      ];

      dispatch(addDataToMap({ datasets: datasets, config: keplerConfig }))
    }
  }, [cycleData])

  return (
    <>
      {loading && !error && (
        <>
          <LoadingContent />
          <ProgressBar
            label="Descargando Reporte"
            helperText={helperText}
            value={progress}
            max={100}
            status={progress === 100 ? 'finished' : 'active'}
          />
        </>
      )}
      {!loading && error && (
        <>
          <Card $justifyContent='flex-start'>
            <Map size={18} />
            <Typography className='cds--type-heading-compact-01'>
              MAPA
            </Typography>
          </Card>
          <InformationContainer description="Seleccione una fecha para que el mapa realice la búsqueda de datos." />
          <div
            style={{
              display: 'flex',
              gap: '1rem',
              alignItems: 'flex-end',
              marginBottom: '40px'
            }}
          >
            <DatePicker
              datePickerType="single"
              maxDate={yesterday.toISOString()}
              onChange={dispatchReport}
              value={dateValue}
              dateFormat="d-m-Y"
            >
              <DatePickerInput
                placeholder="dd/mm/yyyy"
                labelText="Fecha del Reporte"
                id="daily-datepicker-error"
                size="md"
              />
            </DatePicker>

            <Button
              kind="ghost"
              size="md"
              renderIcon={Launch}
              href="https://youtu.be/HZ9s4VnmVZQ?si=ZqJYk3ctIaDcGHXx"
              target="_blank"
              rel="noreferrer"
            >
              Ver tutorial
            </Button>
          </div>

          <CardComponent width="10%">
            <Typography className='cds--type-heading-compact-01'>
              No hay datos para este dia
            </Typography>
          </CardComponent>
        </>
      )}
      {!loading && !error && (
        <>
          <Card $justifyContent='flex-start'>
            <Map size={18} />
            <Typography className='cds--type-heading-compact-01'>
              MAPA
            </Typography>
          </Card>
          <InformationContainer description="Seleccione una fecha para que el mapa realice la búsqueda de datos." />
          <div
            style={{
              display: 'flex',
              gap: '1rem',
              alignItems: 'flex-end',
              marginBottom: '40px'
            }}
          >
            <DatePicker
              datePickerType="single"
              maxDate={yesterday.toISOString()}
              onChange={dispatchReport}
              value={dateValue}
              dateFormat="d-m-Y"
            >
              <DatePickerInput
                placeholder="dd/mm/yyyy"
                labelText="Fecha del Reporte"
                id="daily-datepicker-error"
                size="md"
              />
            </DatePicker>

            <Button
              kind="ghost"
              size="md"
              renderIcon={Launch}
              href="https://youtu.be/HZ9s4VnmVZQ?si=ZqJYk3ctIaDcGHXx"
              target="_blank"
              rel="noreferrer"
            >
              Ver tutorial
            </Button>
          </div>

          <div style={{ height: "93vh", width: "96vw" }}>
            <AutoSizer>
              {({ height, width }) => (
                <KeplerGl
                  id="map"
                  mapboxApiAccessToken={MAPBOX_TOKEN}
                  width={width}
                  height={height}
                />
              )}
            </AutoSizer>
          </div>
        </>
      )}
    </>
  );
};

export default KeplerMapContainer;
